<template>
  <div class="Camera" />
</template>
<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'Camera',
  render: (h) => h(),
  data: ()=>({
    used: false
  }),
  beforeCreate() {
    this.$camera = this.$parent.$camera
    this.$scene = this.$parent.$scene
    this.$canvas = this.$parent.$canvas

	  this.panPosition = new BABYLON.Vector3(0, 30, -200)

    this.$camera.minZ = 1.25
    this.$camera.speed = 1
    this.$camera.maxZ = 20000
    this.$camera.position = _.clone(this.panPosition)
    this.$camera.setTarget(new BABYLON.Vector3(0, 0, 0))
    this.$camera.keysUp.push(87) // "w"
    this.$camera.keysDown.push(83) // "s"
    this.$camera.keysLeft.push(65) // "a"
    this.$camera.keysRight.push(68) // "d"

    if(this.$root.$agent.mobile) {
      this.$camera.angularSensibility = 10
      this.$camera.moveSensibility = 10
      this.$camera.attachControl(this.$canvas)
    } else {
      this.$camera.angularSensibility = 10000
      this.$camera.moveSensibility = 10000
    }

    this.$explorer = new BABYLON.FreeCamera('CameraExplorer', _.clone(this.panPosition), this.$scene)
  },
  mounted() {
    TweenMax.set(this.$el, { autoAlpha: 0 })
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        if(this.slugIsIn(['secret']) || this.slugIsBefore('instructions')) {
          this.$scene.activeCamera = this.$explorer
          this.$camera.detachControl(this.$canvas)

          if(this.slugIsIn(['pan'])) {
            this.$explorer.rotation = new BABYLON.Vector3(0, -1.2, 0)
            this.$explorer.position = _.clone(this.panPosition)
            TweenMax.to(this.$el, 2, { autoAlpha: 1, delay: 8 })
            TweenMax.to(this.$el, 1, { autoAlpha: 0, delay: 12 })
            TweenMax.to(this.$explorer.rotation, 10, { y: 1, ease: Linear.easeInOut, onComplete: () => this.next() })
          }

          if(this.slugIsIn(['secret'])) {
            this.$explorer.rotation = new BABYLON.Vector3(0, -3.02, 0)
            this.$explorer.position = new BABYLON.Vector3(80, 30, -105)
            TweenMax.to(this.$explorer.rotation, 5, { y: '+=.1', ease: Linear.easeInOut, onComplete: this.next })
          }

        } 
        else if(this.slugIsIn(['monde', 'monde:1', 'monde:2']) && !this.used || this.$route.meta.name == 'artwork' && !this.used) { 
          this.used = true
          this.$camera.setTarget(new BABYLON.Vector3(50, 30, 0))
          this.$camera.position = new BABYLON.Vector3(45, 30, -450)  
        }
        else {
					this.$scene.activeCamera = this.$camera
          this.$camera.attachControl(this.$canvas)
        }
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Camera
  position fixed
  width 100vw
  height 100vh
  background black
  opacity 0

</style>



// WEBPACK FOOTER //
// src/components/world/elements/Camera.vue